<template>
    <div v-for="(item, key) in cart" class="cart-item bg-alt-yellow p-2 extra-rounded my-2 flex-x center-x">

        <div style="display: flex; align-items: center;">
            <div class="cart-item-image" :style="{ backgroundImage: this.URL(item.images[0].path) }"></div>
            <div class="flex-y mx-3">
                <h5 style="margin-bottom: 0px;" v-text="`${item.name}`"></h5>
                <div v-if="item.selected_options.length > 0" class="flex-y">
                    <span v-for="option in item.selected_options">{{ option.group.name }}: {{ option.name }}</span>
                </div>
            </div>
        </div>

        <div class="flex-x center-x">
            <input style="width: 50px" type="number" :value="`${ item.quantity }`" @change="this.UpdateQuantity(key, item.quantity)" class="form-control item-quantity mx-2 rounded"/>
            <i class="fas fa-trash delete-cart-item mx-4" @click="this.Delete(key)"></i>
            <h5 class="mx-4 my-0" v-text="`£${this.TotalPrice(item)}`"></h5>
        </div>
    </div>
</template>

<script>

export default {

    data () {
        return {
            cart: []
        }
    },

    created () {
        this.cart = this.items;
    },

    methods: {

        TotalPrice ( item ) {
            var price = parseFloat(item.price);
            item.selected_options.forEach((option) => {
                if ( option.price_modifier != 0 && option.price_modifier != undefined ) price += parseFloat(option.price_modifier);
            });
            return price;
        },

        URL (path) {
            return 'url(' + window.location.origin + '/storage/' + path + ')';
        },

        UpdateQuantity (key, quantity) {
            console.log(key, quantity);
        },

        Delete(key) {

            axios.post('/cart/remove', {
                key: key
            })
            .then( (response) => {

                Toast(response.data.item_name + " removed from cart");

                this.cart.splice(key, 1);

                if ( response.data.cart_total > 0 ) {
                    $('#cart-total').text(response.data.cart_total);
                } else {
                    location.reload()
                }
  
            })
            .catch(function (error) {
                console.log(response);
            });

        }

    },

    props: ['items']

}

</script>